import {
    LOCATION_CHANGE_REGISTER,
    REGISTER_KICKED,
    REQUEST_REGISTER,
} from "../../Actions/General/GeneralActionConstants";
import {
    type LocationActionTypes,
    type LocationState,
} from "../../Actions/General/LocationActions";
import { PRESENCE_OVERRIDE } from "../../Actions/General/PresenceActions";
import { clearStoredCashCalculator } from "../../Utilities/Domain/Sales/SalesUtilities";
import { type ShopfrontActions } from "../../Utilities/Generic/ActionsHelper";
import { getOption, setOption } from "../../Utilities/Platform/Options/Options";

function requestRegister(): LocationState {
    void clearStoredCashCalculator();
    const prevRegister = getOption("register");

    if(prevRegister) {
        setOption("previous_register", prevRegister);
    }

    setOption("register", getOption("register_kicked") ? null : "");
    setOption("register_name", "");
    setOption("outlet", "");
    setOption("outlet_name", "");

    return {
        outlet  : null,
        register: null,
        kicked  : false,
        inUse   : false,
        isGlobal: false,
    };
}

function LocationReducer(state: LocationState, action: ShopfrontActions<LocationActionTypes>): LocationState {
    if(typeof state === "undefined") {
        const isGlobal = getOption("global_mode");

        return {
            kicked: false,
            inUse : false,
            outlet: isGlobal ? null : {
                id  : getOption("outlet"),
                name: getOption("outlet_name"),
            },
            register: isGlobal ? null : {
                id  : getOption("register"),
                name: getOption("register_name"),
            },
            isGlobal,
        };
    }

    switch(action.type) {
        case LOCATION_CHANGE_REGISTER:
            clearStoredCashCalculator();

            return {
                outlet  : action.outlet,
                register: action.register,
                isGlobal: action.global,
                kicked  : false,
                inUse   : false,
            };
        case REQUEST_REGISTER:
            return requestRegister();
        case REGISTER_KICKED:
            clearStoredCashCalculator();
            setOption("previous_register", action.register);

            return {
                ...state,
                register: null,
                inUse   : false,
                isGlobal: false,
                kicked  : {
                    user    : action.user,
                    register: action.register,
                },
            };
        case PRESENCE_OVERRIDE:
            return {
                ...state,
                inUse: action.inUse,
            };
    }

    return state;
}

export default LocationReducer;
